/**
 * siteWideAlert.js
 * @author Cody Marcoux (Studio123)
 */

const setAlertGutter = () => {
    $(".gutter").css("height", $("#site-wide-alert").height());
};

window.addEventListener("resize", () => {
    setAlertGutter();
});

const dismissAlert = (alertId) => {
    let dismissedAlerts = sessionStorage.getItem("dismissed-alerts");

    if (!dismissedAlerts) {
        dismissedAlerts = [];
    } else {
        dismissedAlerts = JSON.parse(dismissedAlerts);
    }

    !dismissedAlerts.includes(alertId) && dismissedAlerts.push(alertId);

    sessionStorage.setItem("dismissed-alerts", JSON.stringify(dismissedAlerts));
};

// Check for alerts on load
const getAlert = () => {
    let currentSiteId = $("body").attr("data-site-id");
    
    // Get the main domain by removing subdomain
    let hostname = window.location.hostname;
    let hostnameParts = hostname.split(".");
    let mainDomain = hostnameParts.length > 2 
        ? hostnameParts.slice(-2).join(".") // Remove subdomain (e.g., "school.grandnord.ca" -> "grandnord.ca")
        : hostname; // Fallback if already main domain
    
    // Construct API URL with main domain
    let protocol = window.location.protocol;
    let apiUrl = `${protocol}//${mainDomain}/wp-json/grandnord/v1/alerts`;
    
    if (currentSiteId) {
        apiUrl += "?site_id=" + currentSiteId;
    }
    
    $.ajax({
        url: apiUrl,
        type: "GET",
        dataType: "json",
    }).done(function (data) {
        let currentLanguage = $("body").attr("data-language");
        let dismissedAlerts = sessionStorage.getItem("dismissed-alerts");

        dismissedAlerts ??
            (dismissedAlerts = JSON.parse(dismissedAlerts)) ??
            (dismissedAlerts = []);

        if (data && data.length > 0) {
            let nonDismissedAlerts = [];

            data.forEach(function (alert) {
                let alertId = alert.id;
                let alertHtml = currentLanguage === "en" ? alert.en : alert.fr;

                if (!dismissedAlerts.includes(alertId)) {
                    nonDismissedAlerts.push($(alertHtml));
                }
            });

            if (nonDismissedAlerts.length > 0) {
                $("#site-wide-alert").html(nonDismissedAlerts);

                setAlertGutter();

                $(".close-alert").on("click", function (e) {
                    e.preventDefault();

                    let alert = $(this).parents(".partial--site_wide_alert");

                    let alertId = alert.data("alert-id");

                    dismissAlert(alertId);

                    alert.fadeOut(200, () => {
                        setAlertGutter();
                    });
                });
            }
        }
    }).fail(function () {
        // Silently fail - alerts are not critical for page functionality
        console.warn("Failed to load alerts from REST API");
    });
};
